function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M5 17h14c1.66 0 3-1.34 3-3v-4c0-1.66-1.34-3-3-3H5c-1.66 0-3 1.34-3 3v4c0 1.66 1.34 3 3 3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.75 7v5c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7h1.5zm-12 0v3.8c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7h1.5zm4.04 0l-.04 5.01c0 .41-.34.74-.75.74h-.01a.75.75 0 01-.74-.76L9.29 7h1.5zm3.96 0v2.6c0 .41-.34.75-.75.75s-.75-.34-.75-.75V7h1.5z"
})));